import { ContentCopy, Delete, Edit } from '@mui/icons-material';
import React from 'react';

import { WeeklyWorkLog } from '@/types';

type CardMenuItemsProps = {
  log: WeeklyWorkLog;
  handleDelete: () => void;
  handleEdit: () => void;
  handleCopy: () => void;
};
const iconSx = { width: '14px', height: '14px' };

export function useLogCardMenuItems({
  log,
  handleDelete,
  handleEdit,
  handleCopy,
}: CardMenuItemsProps) {
  return React.useMemo(
    () => [
      {
        label: 'Редактировать',
        icon: <Edit sx={iconSx} />,
        action: handleEdit,
      },
      {
        label: 'Дублировать',
        icon: <ContentCopy sx={iconSx} />,
        action: handleCopy,
      },
      {
        label: 'Удалить',
        icon: <Delete sx={iconSx} />,
        action: handleDelete,
        danger: true,
      },
    ],
    [log, handleDelete],
  );
}
